import { render, staticRenderFns } from "./OnlineTemplateRepoViewer.vue?vue&type=template&id=0496a28c&scoped=true&"
import script from "./OnlineTemplateRepoViewer.vue?vue&type=script&lang=js&"
export * from "./OnlineTemplateRepoViewer.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTemplateRepoViewer.vue?vue&type=style&index=0&id=0496a28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496a28c",
  null
  
)

export default component.exports